// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Analytics48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Analytics48: FC<Analytics48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M9 42c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1V6h3v33h33v3H9Zm3.75-6.75v-16.7h5.95v16.7h-5.95Zm9.9 0v-27h5.95v27h-5.95Zm9.7 0v-8.5h5.95v8.5h-5.95Z" />
        </svg>
    );
};

export default Analytics48;
